import * as ActionTypes from "../actions/types";

// Last Core error reported by the redux-cycles request layer (see cycles/apiErrors.js).
// ApiErrorToaster turns each new entry into a toast.
const INITIAL_STATE = {
  last: null,
};

function apiErrorNotified(state, action) {
  const seq = state.last ? state.last.seq + 1 : 1;
  state.last = { ...action.payload, seq, at: Date.now() };
}

export const apiErrors = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.API_ERROR_NOTIFIED]: apiErrorNotified,
  },
};
